module.exports = __webpack_public_path__ + "static/media/logo_indihome-dark.0d50557a.png";